export default "__VITE_ASSET__71adbe88__"